export default __webpack_public_path__ + "static/img-orbital-nav-highlight-894e8d87f73b4bedd4b131c0610429cd.jpg";